import { render, staticRenderFns } from "./sourceConflictInfo.vue?vue&type=template&id=1f229c0a&scoped=true"
import script from "./sourceConflictInfo.vue?vue&type=script&lang=js"
export * from "./sourceConflictInfo.vue?vue&type=script&lang=js"
import style0 from "./sourceConflictInfo.vue?vue&type=style&index=0&id=1f229c0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f229c0a",
  null
  
)

export default component.exports